import { ReactElement } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

export const UsersTableHead = (): ReactElement => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>ID</TableCell>
        <TableCell>FULL NAME</TableCell>
        <TableCell>EXPERIENCE</TableCell>
        <TableCell>CREDIT</TableCell>
        <TableCell>EMAIL</TableCell>
        <TableCell>LAST ACTIVE DATE</TableCell>
        <TableCell>STATUS</TableCell>
        <TableCell>ACTIONS</TableCell>
      </TableRow>
    </TableHead>
  );
};
